import { render, staticRenderFns } from "./GlobalNotificationsPanel.vue?vue&type=template&id=6f9c0f3e&scoped=true"
import script from "./GlobalNotificationsPanel.vue?vue&type=script&lang=js"
export * from "./GlobalNotificationsPanel.vue?vue&type=script&lang=js"
import style0 from "./GlobalNotificationsPanel.vue?vue&type=style&index=0&id=6f9c0f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9c0f3e",
  null
  
)

export default component.exports